import store from '../store';
export default {
  /**
   * 转换sku数据格式
   */
  changeSpec(specList) {
    const array = specList?.reduce((arr, item) => {
      const res = item.children.map((val) => {
        return {
          id: val.id,
          name: item.name + "-" + val.name,
          currentPrice: val.currentPrice,
          originalCost: val.originalCost,
          stock: val.stock,
        };
      });
      arr.push(...res);
      return arr;
    }, []);
    // 价格
    let currentPrice;
    try {
      const priceArr = array.map((item) => item.currentPrice);
      const priceRange = [Math.min(...priceArr), Math.max(...priceArr)];
      if (priceRange[0] == priceRange[1]) {
        currentPrice = priceRange[0];
      } else {
        currentPrice = priceRange[0] + "~" + priceRange[1];
      }
    } catch (error) {}
    // 门市价
    let originalCost;
    try {
      const price = array.map((item) => item.originalCost);
      const range = [Math.min(...price), Math.max(...price)];
      if (range[0] == range[1]) {
        originalCost = range[0];
      } else {
        originalCost = range[0] + "~" + range[1];
      }
    } catch (error) {}
    // 床位
    let stock;
    try {
      stock = array.map((item) => item.stock);
      const range = [Math.min(...stock), Math.max(...stock)];
      if (range[0] == range[1]) {
        stock = range[0];
      } else {
        stock = range[0] + "~" + range[1];
      }
    } catch (error) {}
    return [array, currentPrice, originalCost, stock];
  },
  getFutureMonthDay(sourceDate, monthNum = 3) {
    const d = new Date(sourceDate);
    //来源
    const SY = d.getFullYear();
    const SM = d.getMonth();
    const SD = d.getDate();
    // 每个月按照30天算
    let after = Math.round(new Date(sourceDate) / 1000) + 86400 * 30 * monthNum - 86400
    after = new Date(after * 1000)
    let month = after.getMonth() + 1;
    month = month > 9 ? month : "0" + month;
    let day = after.getDate();
    day = day > 9 ? day : "0" + day;
    return [after.getFullYear(), month, day].join("-");
    //结果
    const mydate = new Date(SY, String(SM + monthNum).padStart(2, "0"), String(SD).padStart(2, "0"));
    const yyyy = mydate.getFullYear();
    let MM = (mydate.getMonth() + 1).toString().padStart(2, "0");
    let dd = mydate.getDate().toString().padStart(2, "0");
    //如果月份是2月，就进行闰年和非闰年处理，防止出现类似2月30的情况
    if (MM == 2 && dd > 28) {
      if (yyyy % 100 == 0 && yyyy % 400 == 0) {
        dd = 29;
      } else if (yyyy % 100 != 0 && yyyy % 4 == 0) {
        dd = 29;
      } else {
        dd = 28;
      }
    }
    return `${yyyy}-${MM}-${dd}`;
  },
  /**
   * 将一维数组切割为二维数组
   * @param {*} array
   * @param {*} count
   */
  array_chunk(array, count) {
    let data = [];
    for (let i = 0; i < array.length; i += count) {
      data.push(array.slice(i, i + count));
    }
    return data;
  },
  px2rem(px) {
    if (/%/ig.test(px)) { // 有百分号%，特殊处理，表述pc是一个有百分号的数，比如：90%
      return px
    } else {
      return (parseFloat(px) / 165) + 'rem'
    }
  },
  getToday() {
    const date = new Date();
    let month = date.getMonth() + 1;
    month = month > 9 ? month : "0" + month;
    let day = date.getDate();
    day = day > 9 ? day : "0" + day;
    return [date.getFullYear(), month, day].join("-");
  },
  /**
   * 是否为游客模式
   * true|false 是|否
   */
  isTourist() {
    return !store.getters.token
  }
};